import React from "react";
import { useRouter } from "next/router";
import { Button } from "components/button";
import { Arrow } from "container/study-abroad/study-abroad.style";
import { SwitchMainCategory, SwitchMainHeading } from "utils/blog-category";
import { BlogCardFooter, MoreBlogContainer } from "./blog-card.style";

const MoreBlog = ({ article }) => {
   const router = useRouter();

   const handleSingleBlog = () => {
      router.push(`/blog/${article?.slug}`);
      localStorage.setItem("blogCategory", SwitchMainCategory(article?.categories));
   };

   return (
      <MoreBlogContainer>
         <div className="flex-category">
            <div className="text-content">
               <h3 className="category">{SwitchMainHeading(article?.categories)}</h3>
               <h3 className="title">{article?.title}</h3>
               <div className="content">{trimArticle(article?.summary)}...</div>
               <BlogCardFooter>
                  <Button size="small" variant="link" onClick={handleSingleBlog}>
                     <span style={{ display: "flex", alignItems: "center" }}>
                        Read More
                        <Arrow style={{ marginLeft: "5px" }} />
                     </span>
                  </Button>
               </BlogCardFooter>
            </div>
            <div className="image-content">
               <img className="img-container" src={article?.imageUrl} alt="" />
            </div>
         </div>
      </MoreBlogContainer>
   );
};

function trimArticle(str) {
   return str.split(/\s+/).slice(0, 14).join(" ");
}

export default MoreBlog;
